import React, { useEffect, useState } from 'react'
import { browserHistory } from 'react-router';
import { assetsType } from '../../../../constants';
import { ContractWrapper, LeaseDetialTab } from '../../../../lease_management/Elements';
import EngineRightCard from '../components/EngineRightCard';
import EditEngineRight from '../components/EditEngineRight';
import { globalGetService, globalPostService, globalPutService } from '../../../../globalServices';
import { PageLoader } from '../../../../shared_elements';
import { ContractSideBar, EditSidebar, Header } from '../../../../applications/contracts/Elements';

export default function EngineRight(props) {
    const [editModal, setEditModal] = useState({ modal: false });
    const [engineRight, setEngineRight] = useState({});
    const [isLoading, setLoading] = useState(false);
    useEffect(() => {
        getEngineRight();
    }, [])
    const changeMsn = (evt) => {
        let url = '/' + assetsType[evt.asset_type] + '/' + evt.slug + '/contracts';
        browserHistory.push(url);
    }
    const toggleEditSideBar = (data) => {
        setEditModal({ modal: true, data:engineRight })
    }
    const getEngineRight = () => {
        setLoading(true);
        globalGetService(`/contracts/${props.params.contract_slug}/engine-rights/`)
        .then((response) => {
                setLoading(false);
                if (response.status === 200) {
                    setEngineRight(response.data.data);
                }
            })
    }

    const updateContributions = (data, type, assetViewId) => {
        setLoading(true);
        globalPutService(`contracts/${props.params.contract_slug}/engine-rights/${engineRight?.id}/`, data.data)
        .then(response => {
            if (response.status === 200) {
                setEditModal({ modal: false });
                getEngineRight();
            }else{
                setLoading(false);
            }
        }
        )
    }
    return (
        <div className="contract-container">
            { isLoading? <PageLoader /> : null}
            <Header type="brief" headingText="Lease Management" pageTitle="Headlines" params={props.params} changeMsn={changeMsn} />
            <ContractSideBar application="Headlines" type="brief" params={props.params} />
            <div className="contract-content-blk">
                <LeaseDetialTab url='engine-right' primaryTab='technical-details' secondaryTab='engineRight' />
                <ContractWrapper
                    revision={false}
                >
                    <div className="cape-town-convention">
                        <EngineRightCard
                            engineRight={engineRight}
                            toggleEditSideBar={toggleEditSideBar}
                        />
                    </div>
                </ContractWrapper>
            </div>
            {
                editModal.modal ?
                    <EditSidebar
                        title={`Edit Engine Right`}
                        editSideBar={editModal?.modal}
                        toggleEditSideBar={() => setEditModal({ modal: false })}
                    >
                        {editModal?.modal ?
                            <EditEngineRight
                                type="edit"
                                engineRight={engineRight}
                                updateContributions={(data) => updateContributions(data)}
                                toggleEditSideBar={() => setEditModal({ modal: false })}
                            /> : null
                        }
                    </EditSidebar> : null
            }
        </div>
    )
}
